<template>
  <div class="slider-background" ref="container">
    <canvas ref="canvas"></canvas>
    <div class="slider-background__white"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import background from '@/scripts/background';

export default {
  name: 'SliderBackground',

  data() {
    return { };
  },

  computed: {
    ...mapGetters(['loaded']),
  },

  watch: {
    loaded(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          background.ref.init();
          if (this.$store.state.route.name === 'home') background.ref.play();
          else background.ref.pause();
        });
      }
    },
  },

  mounted() {
    background.init(this.$refs.container, this.$refs.canvas);
    background.ref.load().then(() => {
      this.$eventHub.$emit('pixi-load');
    });
  },
};
</script>

<style lang="scss" scoped>
.slider-background {
  @extend %full;

  &__white {
    @extend %full;
    background-color: $color-white;
    pointer-events: none;
  }

  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
